// Matches DB enum
export var DOCUMENT_TYPE;
(function (DOCUMENT_TYPE) {
    DOCUMENT_TYPE["APPLICATION_FORM"] = "APPLICATION_FORM";
    DOCUMENT_TYPE["CREDIT_CHECK_REPORT"] = "CREDIT_CHECK_REPORT";
    DOCUMENT_TYPE["DEPOSIT_AGREEMENT"] = "DEPOSIT_AGREEMENT";
    DOCUMENT_TYPE["GOOGLE_DRIVE_PRIVATE_FOLDER"] = "GOOGLE_DRIVE_PRIVATE_FOLDER";
    DOCUMENT_TYPE["GOOGLE_DRIVE_PUBLIC_FOLDER"] = "GOOGLE_DRIVE_PUBLIC_FOLDER";
    DOCUMENT_TYPE["HOME_INSPECTION_REPORT"] = "HOME_INSPECTION_REPORT";
    DOCUMENT_TYPE["IDENTITY_CHECK_REPORT"] = "IDENTITY_CHECK_REPORT";
    DOCUMENT_TYPE["INVOICE"] = "INVOICE";
    DOCUMENT_TYPE["NOTICE_OF_ASSESSMENT"] = "NOTICE_OF_ASSESSMENT";
    DOCUMENT_TYPE["LETTER_OF_EMPLOYMENT"] = "LETTER_OF_EMPLOYMENT";
    DOCUMENT_TYPE["OTHER"] = "OTHER";
    DOCUMENT_TYPE["OWNER_RESIDENT_AGREEMENT"] = "OWNER_RESIDENT_AGREEMENT";
    DOCUMENT_TYPE["PAY_STUBS"] = "PAY_STUBS";
    DOCUMENT_TYPE["PLAID_BANK_TRANSACTIONS"] = "PLAID_BANK_TRANSACTIONS";
    DOCUMENT_TYPE["PLAID_INCOME_SUMMARY"] = "PLAID_INCOME_SUMMARY";
    DOCUMENT_TYPE["PRE_AUTHORIZED_DEBIT_AGREEMENT"] = "PRE_AUTHORIZED_DEBIT_AGREEMENT";
    DOCUMENT_TYPE["T4"] = "T4";
})(DOCUMENT_TYPE || (DOCUMENT_TYPE = {}));
// Matches DB enum
export var DOCUMENT_STATUS;
(function (DOCUMENT_STATUS) {
    DOCUMENT_STATUS["SUBMITTED"] = "SUBMITTED";
    DOCUMENT_STATUS["AWAITING_SIGNATURE"] = "AWAITING_SIGNATURE";
    DOCUMENT_STATUS["DECLINED"] = "DECLINED";
    DOCUMENT_STATUS["CANCELLED"] = "CANCELLED";
    DOCUMENT_STATUS["OTHER"] = "OTHER";
    DOCUMENT_STATUS["PENDING"] = "PENDING";
})(DOCUMENT_STATUS || (DOCUMENT_STATUS = {}));
// Matches DB enum
export var DOCUMENT_SOURCE;
(function (DOCUMENT_SOURCE) {
    DOCUMENT_SOURCE["CERTN"] = "CERTN";
    DOCUMENT_SOURCE["HELLOSIGN"] = "HELLOSIGN";
    DOCUMENT_SOURCE["MANUAL"] = "MANUAL";
    DOCUMENT_SOURCE["OTHER"] = "OTHER";
    DOCUMENT_SOURCE["PLAID"] = "PLAID";
    DOCUMENT_SOURCE["SIGNWELL"] = "SIGNWELL";
})(DOCUMENT_SOURCE || (DOCUMENT_SOURCE = {}));
// Matches DB enum
export var DOCUMENT_REQUEST_STATUS;
(function (DOCUMENT_REQUEST_STATUS) {
    DOCUMENT_REQUEST_STATUS["REQUESTED"] = "REQUESTED";
    DOCUMENT_REQUEST_STATUS["FULFILLED"] = "FULFILLED";
    DOCUMENT_REQUEST_STATUS["CANCELLED"] = "CANCELLED";
    DOCUMENT_REQUEST_STATUS["REJECTED"] = "REJECTED";
})(DOCUMENT_REQUEST_STATUS || (DOCUMENT_REQUEST_STATUS = {}));
// Matches DB enum
export var DOCUMENT_REQUEST_BUNDLE_STATUS;
(function (DOCUMENT_REQUEST_BUNDLE_STATUS) {
    DOCUMENT_REQUEST_BUNDLE_STATUS["REQUESTED"] = "REQUESTED";
    DOCUMENT_REQUEST_BUNDLE_STATUS["FULFILLED"] = "FULFILLED";
    DOCUMENT_REQUEST_BUNDLE_STATUS["CANCELLED"] = "CANCELLED";
    DOCUMENT_REQUEST_BUNDLE_STATUS["REJECTED"] = "REJECTED";
})(DOCUMENT_REQUEST_BUNDLE_STATUS || (DOCUMENT_REQUEST_BUNDLE_STATUS = {}));
export var DOCUMENT_REQUEST_BUNDLE_SOURCE;
(function (DOCUMENT_REQUEST_BUNDLE_SOURCE) {
    DOCUMENT_REQUEST_BUNDLE_SOURCE["APPLICANT"] = "APPLICANT";
})(DOCUMENT_REQUEST_BUNDLE_SOURCE || (DOCUMENT_REQUEST_BUNDLE_SOURCE = {}));
//# sourceMappingURL=Document.js.map